import React, { useState,useEffect } from 'react'
import './payroll.css'
import { Link } from 'react-router-dom'
import Popover from '@mui/material/Popover';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';
import profile from '../../../assets/profile.png'
import PayrollChart from '../../../components/barCharts/payrollChart';
import { useDispatch, useSelector } from 'react-redux'
import {getAllUsers} from '../../../api'
import {addToPayroll, updatePayroll, fetchPayrolls} from '../../../api/payrollApi'
import {handleStaffs} from '../../../state/userSlice'
import {handleAddPayroll} from '../../../state/payrollSlice'
import moment from 'moment';
import {handleOpenModal, handleCloseModal} from '../../../state/modalSlice'
import Loader from '../../../components/loader/Loader'
import ActionCell from '../../../components/actionCell/ActionCell'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (param)=>{
            return (
                <div className='payroll__table-profile'>
                    <img src={param.row.img} 
                    alt="" className="payroll__table-img" />
                    <div className="payroll__table-profile_list">
                        <h4 className="payroll__table-profile_name">
                            {param?.row?.user?.firstName + ' ' + param?.row?.user?.lastName}
                        </h4>
                        <span className="payroll__table-profile_email">
                            {param?.row?.email}
                        </span>
                    </div>
                </div>
            )
        }
    },
    {
        field: 'staffId',
        headerName: 'Employee ID',
        width: 120,
        renderCell: (param) => (
            <span>
                {param?.row?.user?.staffId}
            </span>
        )
    },
    {
        field: 'department',
        headerName: 'Department',
        width: 150,
        renderCell: (param) => (
            <span>
                {param?.row?.user?.department}
            </span>
        )
    },
    {
        field: 'salary',
        headerName: 'Salary',
        width: 100,
        renderCell: (param) => (
            <span>
                ₦{param?.row?.salary?.toLocaleString('en-US', {minimumFractionDigits: 2,})}
            </span>
        )
    },
    {
        field: 'deduction',
        headerName: 'Deduction',
        width: 100,
        renderCell: (param) => (
            <span>
                ₦{param?.row?.deduction?.filter((item)=>item?.amount)}
            </span>
        )
    },
    {
        field: 'joinDate',
        headerName: 'Join Date',
        width: 120,
        renderCell: (param) => (
            <span>
                {moment(param?.row?.user?.createdAt).format('DD MMMM YYYY')}
            </span>
        )
    },
    {
        field: 'slip',
        headerName: 'Generate Slip',
        width: 120,
        renderCell: (param)=>{
            return (
                <Link to={`/payroll/payslip/${param?.row?._id}`} 
                className='payroll__table-slip_button'>
                    Generate Slip
                </Link>
            )
        }
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 100,
        renderCell: (param) => <ActionCell param={param} payroll={true}/>
    },
];


const AddPayroll = ({user, staffs, closeModal, modal, handleGetPayrolls}) => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        control
    } = useForm({
        mode: 'onChange',
        defaultValues: modal?.data ? modal?.data : ''
    })
    

    const onSubmit = async (data) => {
        setIsLoading(true)
        try{
            const res = await (modal?.data ? updatePayroll(user?.token, data, modal?.data?._id) : addToPayroll(user?.token, data)) 
            if(res?.success){
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reset()
                handleGetPayrolls()
                closeModal()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        }catch(error){
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

    return (
        <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <div className="modal-heading">
                    <h4 className="modal-title">Add to Payroll</h4>
                    <button type='button' onClick={closeModal}
                    className="modal-btn">
                        <i class='bx bx-x'></i>
                    </button>
                </div>
                <form className="modal-form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="modal-items">
                        <div className="modal-field">
                            <label htmlFor="department" className='modal-label'>
                                Staff <span>*</span>
                            </label>
                            <select name="staff" className="modal-input"
                            {...register('staff',{required: 'This field is required!'})}>
                                <option value="" disabled>Select a staff</option>
                                {
                                    staffs?.map((item, i)=>(
                                        <option value={item?._id} key={i}>
                                            {item?.firstName + ' ' + item?.lastName}
                                        </option>
                                    ))
                                }
                            </select>
                            {errors?.staff && (
                                <span className="modal-error">
                                    {errors?.staff?.message}
                                </span>
                            )}
                        </div>
                        <div className="modal-field">
                            <label htmlFor="salary" className='modal-label'>
                                Net Salary <span>*</span>
                            </label>
                            <input type="number" name='salary' className="modal-input" 
                            {...register('salary',{required: 'This field is required!'})}/>
                            {errors?.salary && (
                                <span className="modal-error">
                                    {errors?.salary?.message}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="modal-field bottom">
                        {
                            isLoading ? <Loader/> :  <button type='submit'
                        className='modal-button button'>
                            Submit
                        </button>
                        }
                    </div>
                </form>

            </div>
        </div>
    )
}



const Payroll = () => {
    const {user, staffs} = useSelector((state)=>state.user)
    const {payroll} = useSelector((state)=>state.payroll)
    const {modal} = useSelector((state)=>state.modal)
    const [value, setValue] = useState('')
    const dispatch = useDispatch()

    const openModal = () =>{
        dispatch(handleOpenModal())
    }
    const closeModal = () =>{
        dispatch(handleCloseModal())
    }

    const handleFetchUsers = async () => {
        try{
            const res = await getAllUsers(user?.token)
            dispatch(handleStaffs(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const handleGetPayrolls = async () =>{
        try{
            const res = await fetchPayrolls(user?.token)
            dispatch(handleAddPayroll(res?.data))
        }catch(error){
            console.log(error)
        }
    }
    
    const today = new Date()
    const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, today.getDate());

    const staffsTwoMonthsAgo = staffs?.filter((item) => {
        const createdAtDate = new Date(item?.createdAt);
        return createdAtDate >= twoMonthsAgo && createdAtDate < today;
    });

    useEffect(()=>{
        handleGetPayrolls()
        handleFetchUsers()
    },[])

    const filterItems = payroll?.filter((item)=>{
        return item?.user?.firstName?.toLowerCase().includes(value.toLowerCase())
        || item?.user?.lastName?.toLowerCase().includes(value.toLowerCase())
        || item?.user?.email?.toLowerCase().includes(value.toLowerCase())
    })

    const totalSalary = []
    const totalDeduction = []

    const calculateTotalForMonth = (month, year) => {
        let totalSalaryForMonth = 0;
        let totalDeductionForMonth = 0;
        
        payroll?.forEach(item => {
            const createdAtDate = new Date(item.createdAt);
            if (createdAtDate.getMonth() === month && createdAtDate.getFullYear() === year) {
                totalSalaryForMonth += item.salary;
                totalDeductionForMonth += item.deduction.reduce((acc, curr) => acc + curr.amount, 0);
            }
        });
        
        totalSalary.push(totalSalaryForMonth);
        totalDeduction.push(totalDeductionForMonth);
    };

    for (let month = 0; month <= new Date().getMonth(); month++) {
        calculateTotalForMonth(month, new Date().getFullYear());
    }


  return (
    <section className='payroll'>
         {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Payroll | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Payroll <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    Payroll
                </p>
            </div>
            <button 
            onClick={openModal}
            className="heading__box-btn button">
                Add to Payroll
            </button>
        </div>

        <div className="payroll__container">
            <div className="payroll__chart-container">
                {/* PAYROLL CHART */}
                <PayrollChart totalSalary={totalSalary} totalDeduction={totalDeduction}/>
                {/* PAYROLL STATUS */}
                <div className="payroll__status">
                    <h3 className="payroll__status-title">
                        Payment Status
                    </h3>
                    {/* PAYMENT PROGRESS */}
                    <div className="payroll__status-box">
                        <h4 className="payroll__status-box_title">
                            {staffs?.length} <span>Employees</span>
                        </h4>
                        <div className="payroll__status-progress">
                            <div className="payroll__status-progress_bar">
                                <span style={{width: `${payroll?.filter((item)=>item?.status === 'Paid')?.length}%`}}></span>
                                <span style={{width: `${payroll?.filter((item)=>item?.status === 'Pending')?.length}%`}}></span>
                                <span style={{width: `${payroll?.filter((item)=>item?.status === 'Unpaid')?.length}%`}}></span>
                            </div>
                            <div className="payroll__status-progress_list">
                                <div className="payroll__status-progress_item">
                                    <span></span>
                                    <h4 className="payroll__status-progress_value">
                                        {payroll?.filter((item)=>item?.status === 'Paid')?.length}%
                                    </h4>
                                    <p className="payroll__status-progress_label">Paid</p>
                                </div>
                                <div className="payroll__status-progress_item">
                                    <span></span>
                                    <h4 className="payroll__status-progress_value">
                                        {payroll?.filter((item)=>item?.status === 'Pending')?.length}%
                                    </h4>
                                    <p className="payroll__status-progress_label">Pending</p>
                                </div>
                                <div className="payroll__status-progress_item">
                                    <span></span>
                                    <h4 className="payroll__status-progress_value">
                                        {payroll?.filter((item)=>item?.status === 'Unpaid')?.length}%
                                    </h4>
                                    <p className="payroll__status-progress_label">UnPaid</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* NEW EMPLOYEE */}
                    <div className="payroll__status-user">
                        <div className="payroll__status-user_heading">
                            <h3 className="payroll__status-user_title">
                                New Employee
                            </h3>
                            <Link to={'/employees'} 
                            className='payroll__status-user_link'>
                                View all
                            </Link>
                        </div>
                        <div className="payroll__status-user_profile">
                            {staffsTwoMonthsAgo?.slice(0, 3)?.map((item, i)=>(
                                <div className="payroll__status-user_list" key={i}>
                                    <div className="payroll__status-user_items">
                                        <img src={profile} alt="" 
                                        className="payroll__status-user_img" />
                                        <div className="payroll__status-user_div">
                                            <h4 className="payroll__status-user_name">
                                                {item?.firstName + ' ' + item?.lastName}
                                            </h4>
                                            <span className="payroll__status-user_role">
                                                {item?.role}
                                            </span>
                                        </div>
                                    </div>
                                    <span className="payroll__status-user_date">
                                        {moment(item?.createdAt).format('DD MMMM YYYY')}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* PAYROLL TABLE CONTENT */}
            <div className="payroll__items">
                <div className="payroll__search">
                    <h4 className="payroll__search-title">Payroll</h4>
                    <div className="payroll__search-box">
                        <span className="payroll__search-span">Search:</span>
                        <input type="text" placeholder="Name or email..."
                        value={value} onChange={(e)=>setValue(e.target.value)}
                        className='payroll__search-input'/>
                    </div>
                </div> 

                <div className="payroll__table">
                    <DataGrid
                        getRowId={(rows => rows._id)}
                        rows={filterItems ?? []}
                        columns={columns}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 5,
                            },
                        },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                        getRowHeight={() => 'auto'} 
                        sx={{
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                                py: 0.5,
                            },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                                py: '5px',
                            },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                                py: '10px',
                            },
                        }}
                        experimentalFeatures={{ lazyLoading: true }}
                    />
                </div>
            </div>
        </div>
        {modal?.show && <AddPayroll 
        user={user}
        staffs={staffs}
        modal={modal}
        handleGetPayrolls={handleGetPayrolls}
        closeModal={closeModal}/>}
    </section>
  )
}

export default Payroll